import {useEffect, useRef} from 'react';
import {useMsal} from '@azure/msal-react';
import * as microsoftTeams from '@microsoft/teams-js';
import {Canvas} from '@templates';
import {Loader} from '@atoms';
import {AccountInfo} from '@azure/msal-browser';

const getLoginHint = (account: AccountInfo) => {
  const claims = account.idTokenClaims;

  if (!claims) {
    return;
  }

  // As we don't have the login_hint claim, we need to provide our custom login hint
  const loginHint = claims['sign_in_name'] || claims['email'];
  return loginHint as string;
};

export const TeamsSignOut = () => {
  const {instance} = useMsal();
  const promiseRef = useRef<Promise<void> | null>(null);

  useEffect(() => {
    const signOut = async () => {
      try {
        const activeAccount = instance.getActiveAccount();

        if (activeAccount) {
          const logoutHint = getLoginHint(activeAccount);
          promiseRef.current = instance.logoutRedirect({
            logoutHint: logoutHint,
            postLogoutRedirectUri: window.location.origin + '/teams-signout',
          });

          return;
        }

        if (!promiseRef) return;

        await promiseRef.current;
        microsoftTeams.authentication.notifySuccess('');
      } catch (err) {
        microsoftTeams.authentication.notifyFailure((err as Error).message || 'Signout failed');
      }
    };

    microsoftTeams.app.initialize().then(signOut);
  }, [instance]);

  return (
    <Canvas centerContent>
      <Loader />
    </Canvas>
  );
};
